
import {Container, vec3, Scene, mat4, mat3, Mesh, Light,SphereGeometryBuffer, Material, GeometryBuffer, quat} from '../../beam/index';
import buildMesh from './buildMesh'
import MinimalGLTFLoader from './MinimalGLTFLoader';
import ParticleSystem from '../ParticleSystem'
import settings from '../settings'

const USE_WIREFRAME = false;
let wireframeMaterial;


export default class GLTFLoader {

    constructor(gl, options) {

        this.numMaterialLoaded = 0
        this.numMaterialToLoad = 0

        options.mipmap = options.mipmap != void 0 ? options.mipmap :  settings.mipmap

        this.textureResolution =  options.textureResolution || settings.textureResolution;
        
        this.sceneOffset = options.sceneOffset || 0

        this.gl = gl;
        
        this.options = options;
        this.accessors;

        this.uiElements = []
        
        this.scene      = new Scene()
        this.root     = new Container()
        this.scene.add(this.root)

        this.root.name = 'UE4 root'

        this.cache = {
            materials:  {},
            meshes:     {},
            instancing: {}
        }

        this.onGLTFLoaded()
        this.onSceneInfoLoaded();
    }


    onGLTFLoaded() {

        let glTF = this.options.gltf
        // this.accessors = glTF.accessors;

            // let translate = vec3.create();
            // mat4.getTranslation(translate, glTF.scenes[0].boundingBox.transform);
            // vec3.scale(translate, translate, -1);
            // translate[0] += - 0.5 * glTF.scenes[0].boundingBox.transform[0];
            // translate[1] += - 0.5 * glTF.scenes[0].boundingBox.transform[5];
            // translate[2] += - 0.5 * glTF.scenes[0].boundingBox.transform[10];
            // vec3.copy( this.root.position, translate );





            for (let i=0; i<glTF.scenes[0].nodes.length; i++) {
                let node = glTF.scenes[0].nodes[i];


                
                //has several LOD per primitive
                if (node.children && node.children.length > 0) {

                    this.cache.meshes[ node.name ] = {
                        name: node.name, 
                        primitives:[]
                    };
                    if (node.children[0].mesh) {
                        for (let j=0; j<node.children[0].mesh.primitives.length; j++) {
                            this.cache.meshes[ node.name ]['primitives'].push({
                                instances: [],
                                boudingBox: node.children[0].mesh.primitives[j].boundingBox,
                                material: node.children[0].mesh.primitives[j].material.name.replace(/\..*/,''),
                                LOD: new Array( node.children[0].mesh.primitives.length )
                            });
                        }
                    }

                    for (let j=0; j<node.children.length; j++) {
                        if (node.children[j].mesh) {
                            for (let k=0; k<node.children[j].mesh.primitives.length; k++) {
                                this.cache.meshes[ node.name ]['primitives'][k].LOD[j] = this.buildGeometry( node.children[j].mesh.primitives[k], node.name )
                            }
                        }
                        else {
                            // ('missing primitive', j, node.children[j])
                        }
                    }
                }
                else {

                    if (!node.mesh & node._savedMeshIndex != undefined) {
                        node.mesh = glTF.meshes[ node._savedMeshIndex ]
                    }

                    if (node.mesh) {
                        this.cache.meshes[ node.name ] = {
                            name: node.name, primitives:[], 
                            boudingBox: node.boundingBox,
                            instances: [],
                        };
                        for (let j=0; j<node.mesh.primitives.length; j++) {
                            let geometry = this.buildGeometry( node.mesh.primitives[j], node.name );
                            this.cache.meshes[ node.name ]['primitives'].push({
                                boudingBox: node.mesh.primitives[j].boundingBox,
                                material: node.mesh.primitives[j].material ? node.mesh.primitives[j].material.name.replace(/\..*/,'') : null,
                                LOD: [geometry]
                            });
                        }

                    }
                }
            }

    }



    buildGeometry(primitive, name) {

        let geometry  = new GeometryBuffer(this.gl)

        let indices   = primitive.indices;
        let positions = primitive.attributes.POSITION;
        let normals   = primitive.attributes.NORMAL;

        let colors    = new Float32Array( positions.length );
        for (let i= 0; i<positions.length; i++) { 
            colors[i] = 1.; 
        }

        geometry.length = positions.length / 3
        geometry.addAttribute('index',indices, 1)
        geometry.addAttribute('position', positions, 3)
        geometry.addAttribute('normal', normals, 3)
        geometry.addAttribute('color', new Float32Array(colors), 3);

        if (primitive.attributes.TEXCOORD_0) {
            let uvs = primitive.attributes.TEXCOORD_0;
            geometry.addAttribute('uv', uvs, 2);
        }

        
        // if (!settings.useSingleMesh) {
            
            // const vertices = new Array( positions.length / 3 );
            // const positions2 = new Array( positions.length / 3 );
    
            // let cb = vec3.create(); 
            // let ab = vec3.create();
            // for ( let v = 0, vl = positions.length/3; v < vl; v ++ ) {
            //     vertices[ v ]   = vec3.create()
            //     positions2[ v ] = vec3.create()
            //     vec3.set( positions2[ v ], positions[ v * 3 + 0 ], positions[ v * 3 + 1 ], positions[ v * 3 + 2 ] );
            // }
            // for ( let f = 0, fl = indices.length; f < fl; f += 3 ) {
            //     const face = vec3.create()
            //     vec3.set(face, indices[ f ], indices[ f + 1], indices[ f + 2 ]);
            //     const vA = vec3.create()
            //     vec3.copy( vA, positions2[ face[0] ] );
            //     const vB = vec3.create()
            //     vec3.copy( vB, positions2[ face[1] ] );
            //     const vC = vec3.create()
            //     vec3.copy( vC, positions2[ face[2] ] );
            //     vec3.subtract( cb, vC, vB );
            //     vec3.subtract( ab, vA, vB );
            //     vec3.cross( cb, cb, ab );
            //     vec3.add( vertices[ face[0] ], vertices[ face[0] ],  cb );
            //     vec3.add( vertices[ face[1] ], vertices[ face[1] ],  cb );
            //     vec3.add( vertices[ face[2] ], vertices[ face[2] ],  cb );
            // }
            // for ( let v = 0, vl = vertices.length; v < vl; v ++ ) {
            //     vec3.normalize( vertices[ v ], vertices[ v ] );
            // }
            // let newNormals = []
            // for ( let v = 0, vl = vertices.length; v < vl; v ++ ) {
            //     newNormals.push( vertices[ v ][0] , vertices[ v ][1], vertices[ v ][2]  )
            // }
            // geometry.attributes['normal'].update( new Float32Array(newNormals), 3 )
            //////////////
    
            //TRIANGULATE
            // if (
            //     (settings.useInstancing )
            //     && geometry.attributes.index) {
            //     let indexedPositions = []
            //     let indexedNormals   = []
            //     let indexedUvs       = []
            //     let indexedColors    = []
            //     let _positions       = geometry.attributes.position.data
            //     let _normals         = geometry.attributes.normal.data
            //     let _colors          = geometry.attributes.color.data
            //     let _indices          = geometry.attributes.index.data
            //     let _uvs;
            //     if (geometry.attributes.uv) {
            //         _uvs = geometry.attributes.uv.data 
            //     }
            //     for (let i=0; i<_indices.length; i++) {
            //         let vertexIndex = _indices[ i ];
            //         indexedPositions.push( _positions[vertexIndex*3+0], _positions[vertexIndex*3+1], _positions[vertexIndex*3+2] )
            //         indexedNormals.push( _normals[vertexIndex*3+0], _normals[vertexIndex*3+1], _normals[vertexIndex*3+2] )
            //         if (geometry.attributes.uv) {
            //             indexedUvs.push( _uvs[vertexIndex*2+0], _uvs[vertexIndex*2+1] )
            //         }
            //         indexedColors.push( _colors[vertexIndex*3+0], _colors[vertexIndex*3+1], _colors[vertexIndex*3+2] )
            //     }
            //     geometry.length = indexedPositions.length/3;
            //     geometry.attributes.position.update( new Float32Array( indexedPositions ), 3 );
            //     geometry.attributes.color.update( new Float32Array( indexedColors ), 3 );
            //     geometry.attributes.normal.update( new Float32Array( indexedNormals ), 3 );
            //     if (geometry.attributes.uv) {
            //         geometry.attributes.uv.update( new Float32Array( indexedUvs ), 2 );
            //     }
            //     delete geometry.attributes.index;
            // }
        
        // }

        return geometry;
    }

    mergeMeshes(meshA, meshB, matrix) {
        let tmp = vec3.create()
        for (let i=0; i<meshB.geometry.length; i++) {
            vec3.set( tmp, meshB.geometry.attributes.position.data[i*3+0], meshB.geometry.attributes.position.data[i*3+1], meshB.geometry.attributes.position.data[i*3+2] )
            vec3.transformMat4( tmp, tmp, matrix );
            meshA.position.push(tmp[0], tmp[1], tmp[2])

            vec3.set( tmp, meshB.geometry.attributes.normal.data[i*3+0], meshB.geometry.attributes.normal.data[i*3+1], meshB.geometry.attributes.normal.data[i*3+2] )
            vec3.transformMat4( tmp, tmp, matrix );
            meshA.position.push(tmp[0], tmp[1], tmp[2])

            meshA.color.push(meshB.geometry.attributes.color.data[i*3+0], meshB.geometry.attributes.color.data[i*3+1], meshB.geometry.attributes.color.data[i*3+2])
            meshA.uv.push(meshB.geometry.attributes.uv.data[i*3+0], meshB.geometry.attributes.uv.data[i*3+1])
        }
        return meshA;
    }

    onSceneInfoLoaded() 
    {

        settings.sceneDownscale = this.options.name == 'operationroom' ?  0.05 : 1;

        let resp = this.options.json

        wireframeMaterial = wireframeMaterial || new Material(this.gl,{
            color: [1,0,0],
            wireframe: true
        });

        if (resp.lights) {
            for (let i=0; i<resp.lights.length; i++) {
                if (
                       resp.lights[i].type == 'arealight'
                    || resp.lights[i].type == 'pointlight'
                    || resp.lights[i].type == 'spotlight'
                    || resp.lights[i].type == 'directionallight'
                     ) {

                    if (settings.profile == 0 
                        // && resp.lights.length>20 
                        && resp.lights[i].optional) {
                        continue;//skip spotlights for SD mode to overcome uniforms count limit
                    }

                    let pos = resp.lights[i].position;
                    
                    let light = new Light({
                        width:     resp.lights[i].width  || 50 * settings.sceneDownscale,
                        height:    resp.lights[i].height || 350 * settings.sceneDownscale,
                        type:      resp.lights[i].type,
                        color:     resp.lights[i].color,


                        left:    this.options.left,
                        right:   this.options.right,
                        top:     this.options.top,
                        bottom:  this.options.bottom,
                        near:    this.options.near,

                        distance:  resp.lights[i].type == 'directionallight' ? (100000) * settings.sceneDownscale : resp.lights[i].distance,
                        intensity: resp.lights[i].intensity,//in lumens
                        penumbra:  0,
                        lookAt: [
                            pos[0],
                            0,
                            pos[2]
                        ],	
                        angle:  resp.lights[i].type == 'arealight' ? 0.98 * Math.PI/2 :  0.5 * Math.PI/2,
                        decay:  1.4,
                        shadowMap: true,
                    });


                    light.id = 'light '+i
                    light.position[0] = pos[0] * settings.sceneDownscale
                    light.position[1] = pos[1] * settings.sceneDownscale
                    light.position[2] = pos[2] * settings.sceneDownscale

                    light.rotation[0] = resp.lights[i].rotation[1] * (Math.PI/180) 
                    light.rotation[1] = Math.PI/-2 + (resp.lights[i].rotation[2] * -1) * (Math.PI/180) 
                    light.rotation[2] = 0//resp.lights[i].rotation[0] * -1 * (Math.PI/180) 


                    // if (resp.lights[i].type == 'directionallight') {
                    //     this.scene.sunHelper = new Mesh();
                    //     this.scene.sunHelper.geometry = new SphereGeometryBuffer(this.gl, {
                    //         radius:         1000,
                    //         heightSegments: 32,
                    //         widthSegments:  32,
                    //     });
                    //     this.scene.sunHelper.isHelper = true;
                    //     let sunMaterial = buildMesh(this.gl, { 
                    //         color:             [1, 1, 1],
                    //         emissiveColor: [1, 1, 1],
                    //         emissiveIntensity:100,

                    //     });
                    //     this.scene.sunHelper.material = sunMaterial.material
                    //     this.scene.sunHelper.uniforms = sunMaterial._uniforms;
                    //     this.scene.add( this.scene.sunHelper )
                    // }

                    this.scene.add( light )    
                    this.root.add( light )
                }
            }
        }




        // //CHECK INSTANCING
        let instancesPreCache = {}
        let materialPrecache = {}
        for (let i=0; i<resp.meshes.length; i++) {
            let node  = resp.meshes[i];
            let refMesh = this.cache.meshes[ node.mesh ];
            if ( refMesh ) {
                for (let j=0; j<refMesh.primitives.length; j++ ) {
                    let materialName = refMesh.primitives[j].material;
                    if (  node.materials[j]
                          && (materialName != 'MM_Upper_Body' && materialName != 'MI_ElectricalSupply_Details' && materialName != 'MI_ElectricalSupply' )
                            ) {
                        materialName = node.materials[j];//overide material if nothing is defined on mesh instance
                    }
                    let instancingName = materialName+'__'+node.mesh+'__'+j;
                    if (!instancesPreCache[ instancingName ]) {
                        instancesPreCache[ instancingName ] = 0
                    }
                    instancesPreCache[ instancingName ]++
                    materialPrecache[ materialName ] = materialPrecache[ materialName ] || {}
                    materialPrecache[ materialName ].instancing = instancesPreCache[ instancingName ] > settings.minInstances
                }    
            }
            else {
                console.warn('missing Mesh ref', node, this.cache.meshes)
            }
        }



        //BUILD MATERIALS CACHE
        this.numMaterialToLoad = Object.keys(resp.materials).length
        for (let m in resp.materials) 
        {

            if (m == 'None') {
                continue;
            }

            let mat = resp.materials[m]

            let alpha = 1;

            let albedoMap = mat["BC"] || mat["Albedo"] || mat["albedo"] || mat["Base_Map"] || mat["BaseMap"] || mat["Base Map"] || mat['BaseColorwithAlpha'] || mat['BaseColwithAlpha'] || mat['BaseColour'] || mat['BaseColor'] ||  mat['Base Color'];
            if (albedoMap && typeof albedoMap == 'string') albedoMap = `${this.options.textureDir}${albedoMap}-32x32.jpg`;

            let normalMap = mat["Normal_Map"] || mat["NormalMap"] || mat["N"] || mat["Normal"] || mat["normal"];
            if (normalMap && typeof normalMap == "string") {
                normalMap = `${this.options.textureDir}${normalMap}-32x32.jpg`;
            }
            else {
                normalMap = null;
            }

            let ORMMap = mat["ORM_Map"] || mat["ORMMap"] || mat["ORM"] || mat['AORoughnessMetallic'] || mat['AO Roughness Metallic'] || mat['ARM'];
            if (ORMMap && typeof ORMMap == 'string') {
                ORMMap = `${this.options.textureDir}${ORMMap}-32x32.jpg`;
            }
            else {
                ORMMap = null;
            }

            let metalnessMap = mat["Metallic"]
            if (metalnessMap  && typeof metalnessMap == 'string') {
                metalnessMap = `${this.options.textureDir}${metalnessMap}-32x32.jpg`;
            }
            else {
                metalnessMap = null;
            }

            let roughnessMap = mat["RoughnessMap"] || mat["Roughness"] || mat["roughness"];
            if (roughnessMap && typeof roughnessMap == 'string') {
                roughnessMap = `${this.options.textureDir}${roughnessMap}-32x32.jpg`;
            }
            else {
                roughnessMap = null;
            }
            
            let emissiveMap = mat["E"] || mat['EmissiveColor'] || mat['Emissive Color'] || (mat['Emission'] && mat['Emission'] != 'None' ? mat['Emission'] : null) || null;
            if (emissiveMap && typeof emissiveMap == 'string') {
                emissiveMap = `${this.options.textureDir}${emissiveMap}-32x32.jpg`;
            }
            else {
                emissiveMap = null;
            }

            //TODO: Bug where emissive appear where it shouldnt
            if (
                m == 'MI_ServerBlack' 
                || m == 'MI_ServerRack_EndCap' 
                || m == 'MI_HotIsle_Parts'
                || m == 'MI_ElectricalSupply' 
                || m == 'MI_ServerRack_Cage'
                // || m == 'MI_ElectricalSupply_Details' 
                ) {
                emissiveMap = null;
            }

            let alphaMap = null;
            alphaMap = mat["O"] || mat['AlphaMap'] || mat['Opacity'] || null;
            if (alphaMap && typeof alphaMap == 'string') {
                alphaMap = `${this.options.textureDir}${alphaMap}-32x32.jpg`;
            }
            else {
                alphaMap = null;
            }

            let tiling = (mat['Tiling/Offset'] || mat['Tiling'] ) || [1,1];

            if (mat['UVscale']) {
                tiling = [mat['UVscale'], mat['UVscale']]
            }
            if (mat['UTiling'] && mat['VTiling']) {
                tiling = [mat['UTiling'], mat['VTiling']]
            }

            if ( /windows/.test(m) ) {
                mat["BaseColor"] = [2.44,2.98,4.];
                mat['EmissiveColor'] = [2.44,2.98,4.];
                mat['EmmissiveStrength'] = 1000;
            }

            if ( /lass/.test(m) && !/MI_GlassTest/.test(m) ) {
                mat = {}
                mat["BaseColor"] = [1,1,1];
                mat["Metalness"] = 1;
                mat["Roughness"] = 0;
            }

            //DEBUG
            // if (/MI_GlassTest/.test(m)) {
            //     alpha = 1 - Number(mat['Refraction'])  
            //     mat["blend"] = true;      
            //     mat["BaseColor"] = [1,1,1];
            //     mat["Metalness"] = 1;
            //     mat["Roughness"] = 0;
            //     mat['useReflectionProbe'] = true
            // }
            //DEBUG_END


            if ( Number(mat['Refraction']) > 0) {
                alpha = 1 - Number(mat['Refraction'])
            }

            if ( Number(mat['alpha']) > 0 || Number(mat['Alpha']) > 0) {
                alpha = Number(mat['alpha']) || Number(mat['Alpha']) 
            }

            
            let metalness = 0;
            if (typeof mat["Metallic"] == 'number' ){
                metalness = mat["Metallic"] 
            } 
            else if (typeof mat["metal"] == 'number' ){
                metalness = mat["metal"] 
            }
            else {
               metalness = mat["Metalness"] || mat["metalness"] || 0;
            }


            let _mesh;
            if (settings.useSingleMesh) {
                _mesh = buildMesh(this.gl, { 
                    textureResolution: this.textureResolution,
                    color: [1, 1, 1],
                    mipmap: this.options.mipmap,
                    onLoaded: ()=>{ 
                        this.numMaterialLoaded++; 
                    }
                });
            }
            else {
                _mesh = buildMesh(this.gl, { 
                    // "Dirt Opcaity"
                    // "RefractionDepthBias"
                    // "BaseReflectFractionIn"
                    // "ExponentIn"
                    // "Contrast"
                    // "GrungeMap_Tile"
                    // "Rotation"
                    // "Mask"
    
                    textureResolution: this.textureResolution,
                    tiling: tiling,
                    color: mat["BaseColor"] || mat["Base Color"] || mat["Color"] || mat["CableColour"] || ((mat["BC"] && typeof mat["BC"] != 'string' ? mat["BC"] : [1, 1, 1])) || [1, 1, 1],
                    emissiveMap: emissiveMap||null,
                    alphaMap: alphaMap || null,
                    emissiveColor: mat['EmissiveColor'] || (mat["E"] && typeof mat["E"] != 'string' && !emissiveMap ? mat["E"] : [0,0,0]) ,
                    emissiveIntensity: mat['EmissiveIntensity'] || mat['EmmissiveStrength'] || mat['Emmisive Strength'] || mat['Emissive Intesity'] || mat['emissionmult'] || 1,
                    desaturation:   mat['Desaturation'] || 0,
                    tint:         mat['Tint'] || mat['ColourTint'] || mat['Colour Tint'] || [1,1,1],
                    normalScale:  mat['Normal Intensity'] ?  [mat["Normal Intensity"], mat["Normal Intensity"]] : mat["Normal Strength"] ? [mat["Normal Strength"], mat["Normal Strength"]] : [1,1],
                    metalness,
                    roughness:    mat["Roughness Strength"]||mat["RoughnessStrength"]|| ((typeof mat["Roughness"] == 'number'?mat["Roughness"]:(1)) ),
                    metalnessMap: (typeof metalnessMap == 'string' ? metalnessMap : null),
                    roughnessMap,
                    albedoMap: (typeof albedoMap == 'string' ? albedoMap : null),
                    ORMMap: ORMMap||null,
                    normalMap: normalMap||null,
                    specularIntensity: mat["Specular Intensity"] || 1,
                    mipmap: this.options.mipmap,
                    alpha, 
                    blend: mat['blend'] ? true : false,
                    useReflectionProbe: mat['useReflectionProbe'],
                    useKeeing: mat['useKeeing'],
                    instancing: settings.useInstancing && (materialPrecache[ m ] && materialPrecache[ m ].instancing),
                    onLoaded: ()=>{ 
                        this.numMaterialLoaded++; 
                        if (this.numMaterialLoaded == this.numMaterialToLoad) { 
                        }
                    }
                });
            }

            this.cache.materials[ m ] = {
                blend: mat['blend'],
                program:    _mesh.material,
                uniforms:   _mesh._uniforms
            }
        }//END BUILD MATERIAL CACHE


        let singleMeshData = {
            position:[],
            normal:[],
            uv:[],
            color:[],
        }


        //BUILD SCENE
        for (let i=0; i<resp.meshes.length; i++) 
        {

            let node   = resp.meshes[i];
            let refMesh = this.cache.meshes[ node.mesh ];

            if ( !refMesh ) {
                console.warn('MISSING MESH', node.id, node.mesh)
                continue;
            }

       
            let isPOI = false

            if ( /POI_/.test(node.id.trim() ) ) {
                isPOI = true
            }
                
            let group = new Container();
            group.id   = isPOI ? node.id : node.id;
            group.name = isPOI ? node.name : node.name;
            group.position[0] = node.position[0]
            group.position[1] = node.position[1]
            group.position[2] = node.position[2]
            group.rotation[0] = node.rotation[0] * (Math.PI/180)  // X in UE4
            group.rotation[2] = node.rotation[1] * (Math.PI/180)  // Y in UE4
            group.rotation[1] = node.rotation[2] * (Math.PI/180) * -1 // Z in UE4
            group.scale[0]    = node.scale[0]
            group.scale[1]    = node.scale[1]
            group.scale[2]    = node.scale[2]
            group.static = true;
            group.updateMatrix();
            this.root.add( group );

            
            if (isPOI) {
                this.uiElements.push( group )
            }

            if (refMesh.primitives.length == 0) {
                console.warn('MISSING PRIMTIVES FOR MESH', node.id, node.mesh)
            }

            for (let j=0; j<refMesh.primitives.length; j++ ) 
            {

                let materialName = refMesh.primitives[j].material;//default material defined on mesh primitives
                // TODO: the check here is to fix a bug where some mesh primitives use Emissive map where they shouldnt
                if (
                        materialName != 'MM_Upper_Body'
                        && materialName != 'MI_ElectricalSupply_Details' 
                        && materialName != 'MI_ElectricalSupply' 

                        ) {
                    if (node.materials[j] && node.materials[j] !== null ) {
                        //overide material defined on mesh instance
                        if (this.cache.materials[ node.materials[j] ]) {
                            materialName = node.materials[j];
                        }
                    }
                }

                let instancingName = materialName+'__'+node.mesh+'__'+j;


// //remove these assets because are unoptimised and used 71 times with several indivudual parts
// if (   (node.mesh+'__'+j) == 'server_overhead__1'//red tags
//     || (node.mesh+'__'+j) == 'server_overhead__2'//blue tags
//     || (node.mesh+'__'+j) == 'server_overhead__6'//glass
//     || (node.mesh+'__'+j) == 'SM_Caged_Cables01_SM_Caged_Cables01_x4__1'//ceiling cable cage
//     || (node.mesh+'__'+j) == 'SM_Fire_Equipment_SM_box_03__1'
//     || materialName == 'MI_BaseGlass01'
//     ) {
//         console.warn('SKIP_MESH:', node.mesh, materialName);
//     continue;
// }

                let uniforms = {}
                let material = null;

                if (this.cache.materials[materialName]) {
                    for (let k in this.cache.materials[materialName].uniforms) {
                        uniforms[k] = this.cache.materials[materialName].uniforms[k]
                    }
                    uniforms.uRandomColor = [Math.random(), Math.random(), Math.random()]
                    material = USE_WIREFRAME ? wireframeMaterial : this.cache.materials[materialName].program;
                }
                else {
                    console.warn('missing material', materialName, this.cache.materials)
                }

                let geometry     = refMesh.primitives[j].LOD[ 0 ]//Math.min(1, refMesh.primitives[j].LOD.length - 1) ]//Math.min(1, refMesh.primitives[j].LOD.length - 1) ]

                //TODO check why this occurs
                if (!geometry || !material) {
                    console.warn('MISSING GEOMETRY OR MATERIAL', materialName)
                    continue;
                }
                
                //add the primitive mesh to the parent group, except for instancing > 1 
                if (   isPOI //dont use instancing on POI to more easily retrieve  world position for sreenspace projection
                    || node.animation
                    || !settings.useInstancing 
                    || (!materialPrecache[ materialName ] || (materialPrecache[ materialName ] && !materialPrecache[ materialName ].instancing))
                    ) {


                    let mesh        = new Mesh({});
                    mesh.uniforms   = uniforms;
                    mesh.id         = isPOI ? node.id : node.id + '_Primitive_' + j
                    mesh.name       = isPOI ? node.name : node.name + '_Primitive_' + j;
                    mesh.material   = material
                    mesh.geometry   = !isPOI ? geometry : new SphereGeometryBuffer(this.gl, {radius: 0.0001, widthSegments: 3,heightSegments: 3})
                    mesh.backSided  = node.backSided;
                    mesh.boudingBox = refMesh.primitives[j].boudingBox;
                    mesh.static = true;

                    if (settings.useSingleMesh && !isPOI) {
                        this.mergeMeshes( singleMeshData, mesh, group.matrix )
                    }
                    else {
                        group.add( mesh );
                    }

                }
                else {
                    if (!this.cache.instancing[instancingName] ) {

                        //clone geometry but keep direct reference to the attribute buffers
                        //we clone to prevent issues when a same geometry is used on different materials.
                        let instancedGeometry  = new GeometryBuffer(this.gl)
                        instancedGeometry.length = geometry.length
                        instancedGeometry.attributes.position = geometry.attributes.position 
                        instancedGeometry.attributes.normal   = geometry.attributes.normal 
                        instancedGeometry.attributes.uv       = geometry.attributes.uv
                        instancedGeometry.attributes.color    = geometry.attributes.color
                        if (geometry.attributes.index) {
                            instancedGeometry.attributes.index    = geometry.attributes.index
                        }

                        let mesh        = new Mesh({});
                        mesh.uniforms   = uniforms;
                        mesh.id         = node.id + '_Primitive_' + j
                        mesh.name       = node.name + '_Primitive_' + j;
                        mesh.material   = material
                        mesh.geometry   = instancedGeometry
                        mesh.backSided  = node.backSided;
                        this.root.add( mesh );
                        this.cache.instancing[  instancingName ] = {
                            instances: 0,
                            mesh:      mesh,
                            instanceMatrices: []
                        }
                        mesh.static = true;
                        
                    }
                    let meshModel        = this.cache.instancing[  instancingName ].mesh;
                    let instanceMatrices = this.cache.instancing[  instancingName ].instanceMatrices;
                    instanceMatrices.push.apply( instanceMatrices, group.matrix ) 
                    if (!meshModel.geometry.attributes['instanceMatrix']) {
                        meshModel.geometry.addAttribute( 'instanceMatrix', new Float32Array(instanceMatrices), 16 );
                    }
                    else {
                        meshModel.geometry.attributes['instanceMatrix'].update( new Float32Array(instanceMatrices), 16 );
                    }
                    this.cache.instancing[  instancingName ].instances++;
                    //disbale frustum culling if more than 1 instance
                    meshModel.keep = true;
                }//end instancing
            }

        }//END BUILD SCENE



        
        if (settings.useSingleMesh) {
            let singleMesh;
            let singleGeomeetry  = new GeometryBuffer(this.gl)
            singleGeomeetry.addAttribute( 'position', new Float32Array(singleMeshData.position), 3 );
            singleGeomeetry.addAttribute( 'normal', new Float32Array(singleMeshData.normal), 3 );
            singleGeomeetry.addAttribute( 'uv', new Float32Array(singleMeshData.uv), 2 );
            singleGeomeetry.addAttribute( 'color', new Float32Array(singleMeshData.color), 3 );
            singleMesh            = new Mesh({});
            singleMesh.id         = 'SinglesingleMesh'
            singleMesh.name       = 'SinglesingleMesh'
            singleMesh.geometry   = singleGeomeetry
            singleMesh.static = true;
            this.root.add( singleMesh );
        }


        
        if (settings.useInstancing) {
            window.getInstancing = ()=>{
                return this.cache
            }
        }


        // if (settings.useSingleMesh) {
        //     this.options.onLoaded  && this.options.onLoaded( this.root );
        //     return
        // }

        //PARTICLE SYSTEM (Wheat, dust)
        // TODO: manage menu using particle system and UE4 loader
        if (this.options.particleSystem ){//&& !settings.extraPerfBoost){//} && settings.profile > 0) {
            
            let positions = []
            let targetMesh = this.cache.meshes[ 'SM_Landscape' ].primitives[0].LOD[ 0 ]
            let pos = targetMesh.attributes.position.data;
            
            //convert index geometries to triangles
            if (targetMesh.attributes.index) {
                let idx = targetMesh.attributes.index.data
                for (let i=0; i<idx.length; i+=3) {
                    let pA = [ pos[ idx[i]*3   + 0 ],   pos[ idx[i]*3   + 1 ], pos[ idx[i]*3    + 2 ] ]
                    let pB = [ pos[ idx[i+1]*3   + 0 ], pos[ idx[i+1]*3 + 1 ], pos[ idx[i+1]*3  + 2 ] ]
                    let pC = [ pos[ idx[i+2]*3   + 0 ], pos[ idx[i+2]*3 + 1 ], pos[ idx[i+2 ]*3 + 2 ] ]
                    if (    pA[0] < -50000 
                        || pA[0] > 50000 
                        || pA[2] > 1000
                        || pB[0] < -50000 
                        || pB[0] > 50000 
                        || pB[2] > 1000
                        || pC[0] < -50000 
                        || pC[0] > 50000 
                        || pC[2] > 1000
                        ) {
                       continue;
                    }   
                    positions.push( 
                        pA[0], pA[1], pA[2],
                        pB[0], pB[1], pB[2],
                        pC[0], pC[1], pC[2],
                    )
                }
            }
            else {
                for (let i=0; i<pos.length/3; i+=3) {
                    let pA = [ pos[ (i+0)*3+ 0 ], pos[ (i+0)*3 + 1 ], pos[ (i+0)*3 + 2 ] ]
                    let pB = [ pos[ (i+1)*3+ 0 ], pos[ (i+1)*3 + 1 ], pos[ (i+1)*3 + 2 ] ]
                    let pC = [ pos[ (i+2)*3+ 0 ], pos[ (i+2)*3 + 1 ], pos[ (i+2)*3 + 2 ] ]
                    if (    pA[0] < -50000 
                        || pA[0] > 50000 
                        || pA[2] > 1000
                        || pB[0] < -50000 
                        || pB[0] > 50000 
                        || pB[2] > 1000
                        || pC[0] < -50000 
                        || pC[0] > 50000 
                        || pC[2] > 1000
                        ) {
                       continue;
                    }   
                    positions.push( 
                        pA[0], pA[1], pA[2],
                        pB[0], pB[1], pB[2],
                        pC[0], pC[1], pC[2],
                    )
                }
            }


            let particleSystem = new ParticleSystem(this.gl,{
                size:        settings.numWheatParticles,
                positions,
                geometry:    this.cache.meshes[ settings.wheatMesh ].primitives[0].LOD[0],
                albedoMap:  `${this.options.textureDir}T_Wheat_BC-${this.textureResolution}.jpg`,
                alphaMap:   `${this.options.textureDir}T_Wheat_O-${this.textureResolution}.jpg`,
                normalMap:  `${this.options.textureDir}T_Wheat_N-${this.textureResolution}.jpg`,
            });
            particleSystem.position[0] = -250//-1000 
            particleSystem.position[1] = -2 
            particleSystem.position[2] = -140//1000

            particleSystem.name = 'ParticleSystem'
            particleSystem.id = 'ParticleSystem'
            
            this.root.add( particleSystem );

            // //grass in gravel
            // for (let j=0; j<2; j++) {
            //     for (let i=0; i<8; i++) {
            //         let particleMesh = new ParticleSystem(this.gl,{
            //             size:        2000,
            //             isSmall:     true,
            //             geometry:    this.cache.meshes['SM_Wheat'].primitives[0].LOD[0],
            //             albedoMap:  `${this.options.textureDir}T_Wheat_BC-${this.textureResolution}.jpg`,
            //             alphaMap:   `${this.options.textureDir}T_Wheat_O-${this.textureResolution}.jpg`,
            //             normalMap:  `${this.options.textureDir}T_Wheat_N-${this.textureResolution}.jpg`,
            //         });
            //         particleMesh.position[0] = (j==0 ? -2900 : 5000)  
            //         particleMesh.position[1] = (40)  
            //         particleMesh.position[2] = (9000 + i*5000)  
            //         particleMesh.rotation[2] = j==0 ? -0.05 : 0.05
            //         this.root.add( particleMesh );
            //     }
            // }

            //PRELOAD PARTICLE TEXTURE
            let numLoaded = 0;
            let images = [
                `${this.options.textureDir}T_Wheat_BC-${this.textureResolution}.jpg`,
                `${this.options.textureDir}T_Wheat_O-${this.textureResolution}.jpg`,
                `${this.options.textureDir}T_Wheat_N-${this.textureResolution}.jpg`
            ]
            for (let i=0; i<images.length; i++) {
                let img = new Image()
                img.crossOrigin = "";
                img.onload = ()=>{
                    numLoaded++
                    if (numLoaded==images.length) {
                        this.options.onLoaded  && this.options.onLoaded( this.root );
                    }
                }
                img.src = images[i]
            }
        
        }//END PARTICLE SYSTEM

        else {
            this.options.onLoaded  && this.options.onLoaded( this.root );
        }

    }

}